import React, { useState, useMemo, useCallback } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
    ValidationOverviewBox,
    ValidationIcon,
    ValidationTextContainer,
    ValidationTitle,
    ValidationSubtitle,
    ViewDetailsButton
} from './Validations.styles';
import ValidationsDialog from './ValidationsDialog';
import {
    getValidationStatus,
    getCategoryStats,
    groupByCategory,
    processValidationData
} from './validationUtils';

const Validations = ({ validationData }) => {
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState({});

    // Process and organize validation data
    const flatValidationData = useMemo(() =>
        processValidationData(validationData), 
        [validationData]
    );

    const allPassed = useMemo(() => 
        flatValidationData.every(v => getValidationStatus(v.passed) !== 'failed'),  
        [flatValidationData]
    );
    
    const grouped = useMemo(() => 
        groupByCategory(flatValidationData), 
        [flatValidationData]
    );

    const sortedCategories = useMemo(() =>
        Object.entries(grouped)
            .map(([category, items]) => ({
                category,
                items,
                stats: getCategoryStats(items)
            }))
            .sort((a, b) => b.stats.failed - a.stats.failed),
        [grouped]
    );

    const handleToggle = useCallback((category) => {
        setExpanded(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    }, []);

    return (
        <>
            <ValidationOverviewBox passed={allPassed}>
                <ValidationIcon passed={allPassed}>
                    {allPassed ? <CheckIcon /> : <ClearIcon />}
                </ValidationIcon>
                <ValidationTextContainer>
                    <ValidationTitle>
                        {allPassed ? "Validation Passed" : "Validation Failed"}
                    </ValidationTitle>
                    <ValidationSubtitle>
                        {allPassed
                            ? "Input fields have been verified and passed."
                            : "Please review the failed checks and ensure they are fixed on the finalized version before proceeding."}
                    </ValidationSubtitle>
                </ValidationTextContainer>
                <ViewDetailsButton onClick={() => setOpen(true)}>
                    View Details
                </ViewDetailsButton>
            </ValidationOverviewBox>

            <ValidationsDialog
                open={open}
                onClose={() => setOpen(false)}
                sortedCategories={sortedCategories}
                expanded={expanded}
                onToggle={handleToggle}
            />
        </>
    );
};

export default Validations;